export default __webpack_public_path__ + "static/media/640px-LinkedIn_logo_initials.bb933d68.png";